export const accelerateTypography = {
  // We will need to change this font family to be GM Global Sans before launching it
  fontFamily: "Arial, sans-serif",
  h1: {
    // Application Title
    fontFamily: "Arial, sans-serif",
    fontWeight: 300,
    fontSize: 22,
    lineHeight: '24px',
    fontColor: '#666666',
    '@media (max-width:1279px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 300,
      fontSize: 22,
      lineHeight: '24px',
    },
    '@media (max-width:959px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '18px',
    },
  },
  h2: {
    // Page Title
    fontFamily: "Arial, sans-serif",
    fontWeight: 400,
    fontSize: 30,
    lineHeight: '31px',
    '@media (max-width:1279px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 400,
      fontSize: 27,
      lineHeight: '28px',
    },
    '@media (max-width:959px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 400,
      fontSize: 27,
      lineHeight: '28px',
    },
  },
  h3: {
    // Section Title
    fontFamily: "Arial, sans-serif",
    fontWeight: 300,
    fontSize: 22,
    lineHeight: '24px',
    fontColor: '#666666',
    '@media (max-width:1279px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 300,
      fontSize: 24,
      lineHeight: '30px',
    },
    '@media (max-width:959px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 300,
      fontSize: 24,
      lineHeight: '30px',
    },
  },
  h4: {
    // Information Group Header
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '22px',
    '@media (max-width:1279px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 700,
      fontSize: 18,
      lineHeight: '22px',
    },
    '@media (max-width:959px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 700,
      fontSize: 18,
      lineHeight: '22px',
    },
  },
  h5: {
    // Sub-group/Paragraph/List Headings
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '20px',
    '@media (max-width:1279px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 700,
      fontSize: 16,
      lineHeight: '20px',
    },
    '@media (max-width:959px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 700,
      fontSize: 16,
      lineHeight: '20px',
    },
  },
  h6: {
    // Caption
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '18px',
    '@media (max-width:1279px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '18px',
    },
    '@media (max-width:959px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '18px',
    },
  },
  body1: {
    // Body Copy
    fontFamily: "Arial, sans-serif",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '21px',
    '@media (max-width:1279px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
    },
    '@media (max-width:959px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  body2: {
    // Legal Text (emulates the <small> tag thats defined in the style guide)
    fontFamily: "Arial, sans-serif",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '14px',
    '@media (max-width:1279px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '14px',
    },
    '@media (max-width:959px)': {
      fontFamily: "Arial, sans-serif",
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '18px',
    },
  },
};

export default accelerateTypography;
